/** @format */

import React from "react";
import { useFieldStackSpacing } from "../fieldStackContext";

const FieldShell = ({ id, label, errors, className, children }) => {
  const isInFieldStack = useFieldStackSpacing();

  return (
    <div
      className={`tw-relative tw-w-full tw-text-sm ${
        isInFieldStack ? "" : "tw-mb-[15px]"
      } ${className || ""}`}
    >
      {label && (
        <label
          className="tw-mb-2 tw-block tw-text-base tw-font-bold tw-text-dis-navy"
          htmlFor={id}
        >
          {label}
        </label>
      )}
      {children}
      {errors && (
        <span
          className={`tw-mt-[5px] tw-block tw-text-sm tw-text-dis-error ${
            isInFieldStack ? "" : "tw-mb-[5px]"
          }`}
        >
          {errors.message || "Required"}
        </span>
      )}
    </div>
  );
};

export default FieldShell;
